module.exports = __webpack_public_path__ + "static/img/zsb_title.56b3fa5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zsb_title.png
// module id = GUGj
// module chunks = 1